import type { FieldState } from '../types/fieldState';
import type { FieldEventType } from '../types/fieldEvent';
import { colors } from '../theme/colors';

/**
 * ステートの日本語ラベル
 */
export const FIELD_STATE_LABELS: Record<FieldState, string> = {
  BEFORE_SEEDING: '播種前',
  BEFORE_EMERGENCE: '発芽前',
  INITIAL_GROWTH: '初期生育期',
  PEST_CONTROL: '防除期',
  HARVESTABLE: '収穫期',
};

/**
 * ステートの表示色（Mantine UIカラー名）。
 * Figma の作業色定義に合わせ、各ステートを対応する Mantine 色ファミリーに紐づける。
 */
export const FIELD_STATE_COLORS: Record<FieldState, string> = {
  BEFORE_SEEDING: 'yellow',
  BEFORE_EMERGENCE: 'green',
  INITIAL_GROWTH: 'green',
  PEST_CONTROL: 'teal',
  HARVESTABLE: 'cyan',
};

/**
 * ステート別の推奨度シンボル（○▲×）色。
 * シンボル表示があるステートのみ定義し、それ以外は undefined。
 */
export const FIELD_STATE_SYMBOL_COLORS: Partial<Record<FieldState, string>> = {
  BEFORE_SEEDING: colors.workType.sowing.main,
  PEST_CONTROL: colors.workType.pestControl.main,
};

/**
 * イベントタイプに対応する Material Symbols アイコン名
 */
export const FIELD_EVENT_ICONS: Record<FieldEventType, string> = {
  SEEDING: 'grain',
  EMERGENCE: 'psychiatry',
  PEST_CONTROL: 'sprinkler',
  HERBICIDE: 'grass',
  CULTIVATION: 'agriculture', // placeholder (UI 未実装、 後続 issue で確定)
  HARVEST: 'agriculture',
  TRANSPORT: 'local_shipping',
};
